<template>
  <div>
    <div id="main-wrapper" class="show">
      <div class="header">
        <div class="container">
          <div class="row">
            <div class="col-xl-12">
              <nav class="navbar navbar-expand-lg navbar-light px-0">
                <router-link class="navbar-brand" to="/"
                  ><img src="../../assets/images/w_logo.png" alt="" />
                  <span>Tradient</span></router-link
                >
                <b-navbar-toggle target="navbarSupportedContent">
                </b-navbar-toggle>

                <b-collapse as="div" id="navbarSupportedContent" is-nav>
                  <ul class="navbar-nav">
                    <li class="nav-item">
                      <router-link class="nav-link" to="/"
                        >Dashboard</router-link
                      >
                    </li>
                    <li class="nav-item">
                      <router-link class="nav-link" to="buy-sell"
                        >Buy/Sell</router-link
                      >
                    </li>
                    <li class="nav-item">
                      <router-link class="nav-link" to="accounts"
                        >Accounts</router-link
                      >
                    </li>
                    <li class="nav-item">
                      <router-link class="nav-link" to="settings"
                        >Settings</router-link
                      >
                    </li>
                  </ul>
                </b-collapse>
                <div class="dashboard_log">
                  <div class="d-flex align-items-center">
                    <div class="header_auth">
                      <router-link to="/signin" class="btn btn-success  mx-2"
                        >Sign In</router-link
                      >
                      <router-link
                        to="/signup"
                        class="btn btn-outline-primary  mx-2"
                        >Sign Up</router-link
                      >
                    </div>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div class="authincation section-padding">
        <div class="container h-100">
          <div class="row justify-content-center h-100 align-items-center">
            <div class="col-xl-4 col-md-6">
              <div class="auth-form card">
                <slot />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
    <div class="bg_icons"></div>
  </div>
</template>

<script>
import Footer from "../Footer.vue";
export default {
  components: { Footer },
  name: "AuthLayout",
};
</script>
